/** `src/index.css` dagi `--swatch-*` tokenlarining nomlari. */
export const SWATCH_TOKENS = [
  "--swatch-1",
  "--swatch-2",
  "--swatch-3",
  "--swatch-4",
  "--swatch-5",
  "--swatch-6",
  "--swatch-7",
  "--swatch-8",
] as const;

/**
 * CSS o'zgaruvchisidan olingan qiymatni normallashtiradi.
 *
 * `getComputedStyle` bo'sh satr ham qaytarishi mumkin (token yo'q yoki
 * hujjat hali bo'yalmagan), shuning uchun natija `null` bo'lishi mumkin.
 * Faqat 6 xonali hex qabul qilinadi: ommaviy sayt rangga `1A` alfa qo'shib
 * ishlatadi va bu boshqa formatlar bilan buziladi.
 */
export const normalizeSwatch = (raw: string | undefined | null): string | null => {
  const value = raw?.trim().toLowerCase();
  if (!value) return null;
  if (/^#[0-9a-f]{6}$/.test(value)) return value;
  // Qisqa shakl (#abc) → to'liq shakl.
  const short = /^#([0-9a-f])([0-9a-f])([0-9a-f])$/.exec(value);
  if (short) return `#${short[1]}${short[1]}${short[2]}${short[2]}${short[3]}${short[3]}`;
  return null;
};

/** Hujjatdan barcha palitra ranglarini o'qiydi. */
export const readSwatches = (element: Element | null): string[] => {
  if (!element) return [];
  const styles = getComputedStyle(element);
  return SWATCH_TOKENS.map(token => normalizeSwatch(styles.getPropertyValue(token))).filter(
    (color): color is string => color !== null,
  );
};
